export default "__VITE_PUBLIC_ASSET__6738c1cf__"